<template>
  <div id="app">
    <app-header />
    <navigation-bar />
    <main class="container">
      <router-view></router-view>
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from './components/layout/AppHeader.vue';
import NavigationBar from './components/layout/NavigationBar.vue';
import AppFooter from './components/layout/AppFooter.vue';

export default {
  components: {
    AppHeader,
    NavigationBar,
    AppFooter,
  },
  metaInfo: {
    titleTemplate: 'Gestoría KNK | %s',
  }
}
</script>

<style>
#app {
  --app-gray: #3c4649;
  --app-red: #a50133;
  --app-footer: #19212b;

  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.container {
  position: relative;
  max-width: 980px;
  margin: 0px auto;
  padding: 5px 20px;
}
main.container {
  min-height: 500px;
  padding: 30px 20px 50px 20px;
}
h1, h2, h3, h4 {
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>

